import { useEffect, useState } from "react";
import { toast } from "sonner";
import { LifeBuoy, ChevronDown, ChevronUp, Send } from "lucide-react";
import { api, formatApiError } from "@/lib/api";

const Ticket = ({ t, onReplied }) => {
  const [open, setOpen] = useState(false);
  const [reply, setReply] = useState("");
  const send = async () => {
    if (!reply.trim()) return;
    try { await api.post(`/admin/help-tickets/${t.id}/reply`, { reply }); toast.success("Reply sent"); setReply(""); onReplied(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  return (
    <div className="border border-[#2A2A2A] rounded-xl p-3" data-testid={`admin-ticket-${t.id}`}>
      <button onClick={() => setOpen((o) => !o)} className="w-full flex items-center justify-between gap-3 text-left">
        <span className="min-w-0">
          <span className="text-sm text-white">{t.user_name}</span> <span className="text-xs text-[#A0A0A0]">{t.user_email}</span>
          <span className="block text-xs text-[#C8C8C8] truncate">{t.note || t.messages?.find((m) => m.role === "user")?.text}</span>
        </span>
        <span className="flex items-center gap-2 flex-shrink-0">
          <span className={`text-[10px] px-2 py-0.5 rounded-full ${t.status === "open" ? "bg-[#D4AF37]/20 text-[#D4AF37]" : "bg-[#4ADE80]/15 text-[#4ADE80]"}`}>{t.status}</span>
          {open ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
        </span>
      </button>
      {open && (
        <div className="mt-3 space-y-2">
          <div className="max-h-56 overflow-y-auto space-y-1.5 bg-black/40 rounded-lg p-3">
            {t.messages.map((m, i) => (
              <div key={i} className="text-xs"><span className={m.role === "user" ? "text-[#D4AF37]" : "text-[#A0A0A0]"}>{m.role === "user" ? "Member" : "Velvet"}:</span> <span className="text-white whitespace-pre-line">{m.text}</span></div>
            ))}
          </div>
          {t.reply && <div className="text-xs text-[#4ADE80]">Your reply: <span className="text-white">{t.reply}</span></div>}
          <div className="flex gap-2">
            <input data-testid={`admin-ticket-reply-input-${t.id}`} value={reply} onChange={(e) => setReply(e.target.value)} placeholder={t.reply ? "Send a follow-up…" : "Write your reply…"} className="pe-input flex-1 rounded-full px-4 py-2 text-sm" />
            <button data-testid={`admin-ticket-reply-send-${t.id}`} onClick={send} className="btn-gold px-4 rounded-full"><Send size={14} /></button>
          </div>
        </div>
      )}
    </div>
  );
};

export const HelpInbox = () => {
  const [tickets, setTickets] = useState([]);
  const load = () => api.get("/admin/help-tickets").then((r) => setTickets(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const openCount = tickets.filter((t) => t.status === "open").length;
  return (
    <div className="pe-card rounded-2xl p-6 mb-8" data-testid="admin-help-inbox">
      <div className="font-heading text-2xl mb-1 flex items-center gap-2"><LifeBuoy size={20} className="text-[#D4AF37]" /> Help inbox
        {openCount > 0 && <span className="text-xs font-body px-2 py-0.5 rounded-full gold-gradient text-black" data-testid="admin-help-open-count">{openCount} open</span>}
      </div>
      <div className="text-xs text-[#A0A0A0] mb-4">Questions the help bot passed to you. Your reply appears on the member's Help page.</div>
      {tickets.length === 0 ? <div className="text-sm text-[#A0A0A0]">No requests yet.</div>
        : <div className="space-y-2">{tickets.map((t) => <Ticket key={t.id} t={t} onReplied={load} />)}</div>}
    </div>
  );
};
